var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.989 21.01a6.006 6.006 0 0 1-3.64-1.222A6.064 6.064 0 0 1 30.945 15h-3.903v10.708l-.004 5.865a3.545 3.545 0 0 1-3.738 3.54 3.55 3.55 0 0 1-3.343-3.486 3.543 3.543 0 0 1 4.654-3.42v-3.979a7.65 7.65 0 0 0-1.125-.083 7.47 7.47 0 0 0-5.624 2.525 7.367 7.367 0 0 0-1.847 4.435 7.358 7.358 0 0 0 2.178 5.72A7.465 7.465 0 0 0 23.484 39c.38-.001.757-.03 1.126-.084a7.448 7.448 0 0 0 4.167-2.093 7.351 7.351 0 0 0 2.192-5.22l-.02-8.76A9.85 9.85 0 0 0 37 24.91v-3.902l-.011.001z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    strokeWidth: 2,
    cx: 26.5,
    cy: 26.5,
    r: 27.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitktok);
export default __webpack_public_path__ + "static/media/titktok.9fa9e9dce39f96b3d9b5854f8bf58eda.svg";
export { ForwardRef as ReactComponent };